import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

interface CodeProps {
  itemType: string;
}

export const StyledCodeContainer = styled.span<CodeProps>`
  font-size: ${toRem(12)};
  line-height: ${toRem(14)};
  color: ${baseVariables.color.base10};
  padding: ${toRem(4)};
  box-sizing: border-box;
  border-radius: ${toRem(4)};
  border: ${props => (props?.itemType === 'diet' ? '1px solid #ff8d6b' : `1px dotted ${baseVariables.color.base10}`)};
`;
